import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config/config';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try {
      const isNode = typeof process !== 'undefined' && process.versions && process.versions.node;
      if (isNode) return config.defaultTheme;

      if (typeof window !== 'undefined' && 'localStorage' in window) {
        const savedTheme = localStorage.getItem('theme');
        return savedTheme || config.defaultTheme;
      }
    } catch (e) {
      // Fallback if localStorage produces a SecurityError
    }
    return config.defaultTheme;
  });

  const toggleTheme = () => {
    setTheme((prevTheme) => {
      const newTheme = prevTheme === 'light' ? 'dark' : 'light';
      try {
        const isNode = typeof process !== 'undefined' && process.versions && process.versions.node;
        if (!isNode && typeof window !== 'undefined' && 'localStorage' in window) {
          localStorage.setItem('theme', newTheme);
        }
      } catch (e) {
        // Silently fail if storage is restricted
      }
      return newTheme;
    });
  };

  useEffect(() => {
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
